import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { validationSchema } from '../validationSchema';
import { TOwnershipStructure } from '../types';
import { getInitialValues } from '../utils/utils.tsx';
import { useMemo } from 'react';
import { cloneDeep } from 'lodash';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.tsx';
import {
  selectIsReidentification,
  selectOwnershipStructure,
} from '~/store/identification-form/selectors.ts';

export const useOwnershipStructureForm = () => {
  const formData = useSelector(selectOwnershipStructure);
  const isReidentification = useSelector(selectIsReidentification);
  const { isOwnershipStructureTreeEnabled, isOwnershipStructureTreeReIdentificationEnabled } =
    useFeatureFlags();

  const isFeatureOff = isReidentification
    ? !isOwnershipStructureTreeReIdentificationEnabled
    : !isOwnershipStructureTreeEnabled;

  const initialValues = useMemo(
    () => getInitialValues(formData as TOwnershipStructure, isFeatureOff),
    []
  );

  const form = useForm({
    resolver: yupResolver(validationSchema) as unknown as Resolver<TOwnershipStructure>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
